import { render, staticRenderFns } from "./ZzReservationStatus2Badge.vue?vue&type=template&id=2e30371c&scoped=true&"
import script from "./ZzReservationStatus2Badge.vue?vue&type=script&lang=js&"
export * from "./ZzReservationStatus2Badge.vue?vue&type=script&lang=js&"
import style0 from "./ZzReservationStatus2Badge.vue?vue&type=style&index=0&id=2e30371c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e30371c",
  null
  
)

export default component.exports